module.exports = __webpack_public_path__ + "static/media/design3.2b4667fe.jpg";